import React from 'react';
import styled from 'styled-components';
import { blackRGBA, breakpointsMinWidth } from '../../../../../common/styling';

const VideoWrap = styled.div`
  padding: 16px 16px 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${breakpointsMinWidth.desktopSm} {
    padding: 32px 32px 0 32px;
  }
`;
const Video = styled.iframe`
  border-radius: 16px;
  box-shadow: 4px 4px 16px ${blackRGBA(0.5)};
  width: 250px;
  height: 140px;
  @media ${breakpointsMinWidth.mobileMd} {
    width: 300px;
    height: 170px;
  }
  @media ${breakpointsMinWidth.tabletSm} {
    width: 333px;
    height: 190px;
  }
  @media ${breakpointsMinWidth.tabletMd} {
    width: 438px;
    height: 250px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    width: 600px;
    height: 350px;
  }
  @media ${breakpointsMinWidth.desktopSm} {
    width: 700px;
    height: 400px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    width: 787px;
    height: 450px;
  }
`;

const GridSection = () => {
  return (
    <VideoWrap>
      <Video
        src="https://www.youtube.com/embed/jXz1iVnHKok"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      />
    </VideoWrap>
  );
};

export default GridSection;
